module.exports = __webpack_public_path__ + "static/media/login-bg.98197907.jpg";